import api from "./api";

// ✅ POST request to hire a manager
export const hireManager = async (formData) => {
    try {
        const response = await api.post("/api/hire-manager", formData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Something went wrong!" };
    }
};
